// PRICE-FIRST: "Try again · 15" on a failed frame, clip, sounds or music (the review tray, a failed job line).
import { startStep } from "../actions";
import { retryStep, type PriceStep } from "../price";
import { PaidButton, usePrice } from "./PriceFirst";

const LEDE: Record<Exclude<PriceStep, "script" | "suno">, string> = {
  frame: "A new picture for this scene.",
  clip: "A new video generation of this scene, on the model it's set to.",
  sfx: "New sounds for this scene: effects on the clip and a bed under it. Unused credits come back.",
  music: "A new music bed for the whole video.",
};
const NAME: Record<Exclude<PriceStep, "script" | "suno">, string> = { frame: "frame", clip: "clip", sfx: "sounds", music: "music bed" };

/**
 * "Try again · 15" on a failed frame, clip, sounds or music (review tray, a failed job line): the step's own price,
 * sent with the retry. A clip (video) always asks in the sheet first.
 */
export function RetryButton({ projectId, sceneId, sceneIndex, kind, className = "btn btn-quiet btn-small" }: { projectId: string; sceneId: string | null; sceneIndex?: number; kind: Parameters<typeof retryStep>[0]; className?: string }) {
  const step = retryStep(kind);
  const price = usePrice(projectId, step === "script" || step === "suno" ? null : step, sceneId);
  if (!step || step === "script" || step === "suno") return null;
  const what = sceneIndex ? `scene ${sceneIndex}'s ${NAME[step]}` : `the ${NAME[step]}`;
  return (
    <PaidButton
      price={price}
      label="Try again"
      icon="redo"
      className={className}
      dataAction="job.retry"
      ask={{ title: `Try ${what} again?`, lede: LEDE[step], go: "Try again" }}
      run={(credits) => startStep(projectId, step, { ...(sceneId ? { sceneId } : {}) }, credits)}
    />
  );
}
